import createLucideIcon from '../createLucideIcon';

const Navigation2Off = createLucideIcon('Navigation2OffIcon', [
  ['path', { d: 'M9.31 9.31 5 21l7-4 7 4-1.17-3.17', key: 'qoq2o2' }],
  ['path', { d: 'M14.53 8.88 12 2l-1.17 3.17', key: 'k3sjzy' }],
  ['line', { x1: '2', y1: '2', x2: '22', y2: '22', key: '1w4vcy' }],
]);

export default Navigation2Off;
